import { DEFAULT_PROJECT_VERSION } from '@/constants/scheduleViews';
export const getDefaultState = () => {
  return {
    listOfVersions: [],
    currentVersion: DEFAULT_PROJECT_VERSION,
    issuanceMenu: false,
  };
};
export const state = getDefaultState();
